import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataProductDevelopment } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_PRODUCT_DEVELOPMENT =
  defineMasterdataEntity<MasterdataProductDevelopment>({
    name: 'product-development',
    responseKey: 'productDevelopments',
    displayWith: (p) => keyName(p.key, p.name),
    secondaryWith: (p) => p.description ?? p.product?.name ?? null,
    icon: 'fa-regular fa-flask',
    title: 'Produktentwicklungssuche',
    label: 'Produktentwicklung',
    placeholder: 'Produktentwicklung suchen...',
    columns: [
      {
        label: 'Produktentwicklung',
        type: 'entity',
        icon: 'fa-regular fa-flask',
        value: (e) => keyName(e.key, e.name),
        secondary: (e) => e.description ?? e.product?.name ?? null,
      },
      { label: 'Schlüssel', value: (e) => e.key },
      { label: 'Version', value: (e) => e.version },
      { label: 'Variante', value: (e) => e.variant },
      { label: 'Bezeichnung', value: (e) => e.name },
      { label: 'Beschreibung', value: (e) => e.description },
      { label: 'Stückgewicht', value: (e) => e.unitWeight },
      { label: 'Verpackungsfaktor', value: (e) => e.packagingFactor },
      { label: 'Portionsgewicht', value: (e) => e.portionWeight },
      { label: 'Kunde', value: (e) => e.customer?.name ?? null },
      { label: 'Planmenge', value: (e) => e.plannedQuantity },
      { label: 'Planeinheit', value: (e) => e.plannedUnit },
      { label: 'Planpreis', value: (e) => e.plannedPrice },
      { label: 'Artikel', value: (e) => e.product?.name ?? null },
      { label: 'Hauptwarengruppe', value: (e) => e.productMainGroup },
      { label: 'Untergruppe', value: (e) => e.productSubGroup },
      { label: 'Muster', value: (e) => (e.sample ? 'Ja' : 'Nein') },
      { label: 'Gesperrt', value: (e) => (e.locked ? 'Ja' : 'Nein') },
      { label: 'Gesperrt ab', value: (e) => e.lockedFrom },
      { label: 'Gesperrt bis', value: (e) => e.lockedUntil },
      { label: 'Benutzer', value: (e) => e.user },
      { label: 'Erfassungszeit', value: (e) => e.creationTime },
    ],
  });
